import React from "react";
import { HomeOutlined } from "@ant-design/icons";
import { Result, Modal, Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { sessionEdited, selectFormStatus } from "reducers/formSlice";
import {
	selectWorkflowStatus,
	workflowStatusEdited,
} from "reducers/workflowsSlice";
import { useHistory } from "react-router-dom";
import { selectGlobal } from "reducers/global";

const ResultModal = ({
	visible,
	status,
	title,
	subTitle,
	onClose,
	footer,
	children,
}) => {
	const history = useHistory();
	const { homePath } = useSelector(selectGlobal);
	const handleHome = () => {
		history.push(homePath);
	};
	return (
		<Modal
			open={visible}
			closable={false}
			footer={
				footer
					? footer
					: [
							<Button
								icon={<HomeOutlined />}
								key="home"
								onClick={handleHome}
								type="primary"
								style={{ width: 50 }}
							/>,
							<Button key="close" onClick={onClose}>
								Close
							</Button>,
					  ]
			}
		>
			<Result status={status} title={title} subTitle={subTitle}>
				{children}
			</Result>
		</Modal>
	);
};

const RendererResultModal = () => {
	const status = useSelector(selectFormStatus);
	const workflowStatus = useSelector(selectWorkflowStatus);
	const dispatch = useDispatch();

	//#region notification logic
	const IsResultModalVisible =
		status === "saved" ||
		(workflowStatus !== "idle" &&
			workflowStatus !== "loading" &&
			workflowStatus !== "starting" &&
			workflowStatus !== "failed" &&
			workflowStatus !== "succeeded" &&
			workflowStatus !== "edited" &&
			workflowStatus !== "deleted");

	let resultModalProps = {
		visible: IsResultModalVisible,
	};

	switch (true) {
		case status === "saved":
			resultModalProps = {
				...resultModalProps,
				status: "success",
				title: "Form saved successfully",
				subTitle:
					"You can now close this window and return to this form later, or continue working on this form.",
				onClose: () => {
					dispatch(sessionEdited({ status: "idle" }));
				},
			};
			break;
		case workflowStatus === "submitted":
			resultModalProps = {
				...resultModalProps,
				status: "success",
				title: "Form submitted for approval successfully",
				subTitle:
					"You will be notified when your form is fully approved or is declined by approvers. You can now close this window.",
				onClose: () => {
					dispatch(workflowStatusEdited("idle"));
				},
			};
			break;
		default:
			resultModalProps = {
				...resultModalProps,
				status: "success",
				title: `Workflow ${workflowStatus} successfully`,
				subTitle: "You can now close this window.",
				onClose: () => {
					dispatch(workflowStatusEdited("idle"));
				},
			};
			break;
	}
	//#endregion notification logic

	return <ResultModal {...resultModalProps} />;
};

export default RendererResultModal;
